import type { BanDich } from '../../types';
import type { viRpaKetNoi } from './ket-noi.vi';

export const enRpaKetNoi: Pick<BanDich, keyof typeof viRpaKetNoi> = {
  rpaKetNoi: {
    tieuDe: 'OpenCore connection',
    moTa: 'The address and service JWT the module uses to read projects and workflows and send run commands to your organisation’s OpenCore.',
    chuaKhai: 'Not configured',
    chuaKhaiMoTa:
      'Your organisation has not configured an OpenCore connection. Enter the address and service JWT, then save so the Projects and Workflows screens can read data.',
    capNhatLuc: 'Last updated {{luc}}',
    url: 'OpenCore address',
    urlGoiY: 'Starts with https://, wss:// or grpcs://.',
    urlMau: 'wss://opencore.example.com',
    sdkUrl: 'Run command address',
    sdkUrlGoiY: 'Optional. Leave empty to send commands through the OpenCore address above.',
    jwt: 'Service JWT',
    jwtGoiY: 'Write-only: once saved, the JWT is not shown here again.',
    jwtDaLuu: 'JWT saved',
    jwtChuaCo: 'No JWT yet',
    jwtGiuNguyen: 'Leave empty to keep the current JWT',
    jwtNhap: 'Paste the service JWT',
    goJwt: 'Remove JWT',
    goJwtTieuDe: 'Remove the service JWT?',
    goJwtThan:
      'The module cannot read OpenCore until a new JWT is saved: the Projects and Workflows screens and run commands stop working. This cannot be undone.',
    daGoJwt: 'Removed the service JWT.',
    nangCao: 'Advanced options',
    nangCaoMoTa: 'Usually left at their defaults.',
    workflowsCollection: 'Workflow collection',
    robotsCollection: 'Robot (user) collection',
    collectionGoiY: 'Letters, digits and underscores only.',
    licenseRole: 'Licence role',
    licenseRoleGoiY: 'The OpenCore role that marks users holding an RPA licence.',
    projectRolePrefix: 'Project role prefix',
    projectRolePrefixGoiY: 'Each project’s OpenCore role starts with this prefix.',
    projectWorkflowRights: 'Workflow rights on projects',
    projectProRights: 'Pro rights on projects',
    quyenGoiY: 'OpenCore rights bits, a whole number from 0 to 65535.',
    rpcTimeoutSeconds: 'Run command timeout (seconds)',
    rpcTimeoutGoiY: 'From 30 to 86,400 seconds.',
    maxRetry: 'Retries',
    maxRetryGoiY: 'From 0 to 10.',
    licenseSyncIntervalMinutes: 'Licence sync interval (minutes)',
    licenseSyncGoiY: 'From 1 to 1,440 minutes.',
    enabled: 'Connection on',
    enabledGoiY: 'When off, every screen that reads OpenCore reports the connection is off, and robots take no new runs.',
    loiBatBuoc: 'This field is required.',
    loiUrl: 'The address starts with https://, wss:// or grpcs://, for example wss://opencore.example.com.',
    loiCanJwt: 'Enter the service JWT: without it the module cannot read OpenCore.',
    loiJwtDai: 'The JWT is longer than 8,000 characters. Check the text you pasted.',
    loiCollection: 'Letters, digits and underscores only.',
    loiRole: 'Letters, digits, dots and hyphens only.',
    loiKhoang: 'Enter a whole number from {{min}} to {{max}}.',
    luu: 'Save connection',
    hoanTac: 'Undo',
    daLuu: 'Saved the OpenCore connection.',
    kiemTra: 'Test connection',
    dangKiem: 'Testing...',
    kiemDuoc: 'Connected to OpenCore {{url}}.',
    kiemTruocLuu: 'The test uses the saved connection. Save your changes first, then test.',
    chiXem: 'You can only view the connection. Editing requires the {{quyen}} permission.',
  },
};
